import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NullAsDefault} from 'views/Shared'
import {getId, getType} from "../../../../apis/model/base";
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {Modal} from "antd";
import {withProps} from "recompose";
import LoadingBlock from "../../../Loading/LoadingBlock";
import CRUD from "../../../Shared/enums/CRUD";
import {FetchProductCatalogById} from "../containers/FetchEntity";
import useProductCatalogActions from "./useProductCatalogActions";
import {ProductCatalogFormCreate, ProductCatalogFormEdit} from "../components/ProductCatalogForm";

export const useProductCatalogForm = ({
                                          shop,
                                          autoRefresh = true,
                                      }) => {
    const t = useTranslate()
    const [refreshKey, setRefreshKey] = useState()
    const onError = notifyOnError(t)
    const onRefresh = () => {
        setRefreshKey(Date.now())
        setAction({})
    }

    const owner_type = getType(shop);
    const owner_id = getId(shop);

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        createNewCatalog,
        updateCatalogInfo,
        deleteCatalog
    } = useProductCatalogActions({
        notifyListeners: {
            onCancel: onCancel,
            onRefresh: onRefresh,
        }
    })

    const confirmDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete catalog',
                message: 'are you sure you want to delete this catalog',
                onOk: () => {
                    deleteCatalog({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        const id = getId(params)
        switch (action) {
            case CRUD.CREATE:
            case CRUD.UPDATE:
                setAction({type: action, value: params})
                break
            case CRUD.DELETE:
                confirmDelete(id)
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        if (!!!action?.type) return null;
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        const id = getId(action?.value)
        switch (action?.type) {
            case CRUD.CREATE:
                Component = ProductCatalogFormCreate
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create catalog')}
                        </div>
                    ),
                }
                params = {
                    owner_type,
                    owner_id,
                    shop,
                    onSubmit: (values) => {
                        createNewCatalog(values, {type: 'shop', id: shop?.id})
                    },
                }
                break
            case CRUD.UPDATE:
                Wrapper = withProps({id})(FetchProductCatalogById)
                Component = ProductCatalogFormEdit
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit catalog')}
                        </div>
                    ),
                }
                params = {
                    owner_type,
                    owner_id,
                    item: action?.value,
                    shop,
                    onSubmit: (values) => {
                        updateCatalogInfo(values, {id})
                    },
                }
                break
            default:
                break
        }
        return (
            <Modal
                width={720}
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Component
                                {...params}
                                {...{item, onCancel}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, shop?.id])

    return {
        modal,
        onCancel,
        handleAction,

        confirmDelete,
        refreshKey,

        createNewCatalog,
        updateCatalogInfo,
        deleteCatalog
    }
}
